import { render } from "./AddKeyLanguage.vue?vue&type=template&id=65752c7c&ts=true"
import script from "./AddKeyLanguage.vue?vue&type=script&lang=ts"
export * from "./AddKeyLanguage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__